import "./about.css"

function About1(){
    return(
        <>
        <div className="about-container">
            <div className="about-container2">
                <div className="about-heading">
                    <h1>CHANGING THE BUILDING EXPRIENCES</h1>
                    <p>Page TGK Construction Co. integrates construction management and business relationships to provide unprecedented service, quality, and craftsmanship. With the resolve to change “business as usual”, president T.G.Kalairasan shifted the entire industry. Our unique approach ensures project satisfaction 100% of the time.</p>
                </div>
                <h1 className="mission-heading">MISSION STATEMENT/CORE VALUES</h1>
                <div className="about-missions">
                    
                    <div className="mission-1 mis-1">
                        <img src="https://www.pagebuildingconstruction.com/wp-content/uploads/2017/10/icon-value-added.png" alt="image12"></img>
                        <h2>Value-added Construction Services</h2>
                        <p>We provide value‐added construction services to our customers through innovation, foresight, integrity, and aggressive performance with character and purpose.</p>
                    </div>
                    <div className="mission-1 mis-1">
                    <img src="https://www.pagebuildingconstruction.com/wp-content/uploads/2017/10/icon-partnerships.png" alt="image12"></img>
                        <h2>Successful Client Partnerships</h2>
                        <p>We create a successful partnership with our customers by means of collaborative teamwork and skilled resource management throughout the construction process.</p>
                    </div>
                    <div className="mission-1 mis-1">
                    <img src="https://www.pagebuildingconstruction.com/wp-content/uploads/2017/10/icon-innovation.png" alt="image12"></img>
                        <h2>Building a culture of innovation</h2>
                        <p>We foster a work environment that encourages new ideas, new innovations, and growth. We provide opportunities and incentives to attract and retain the highest caliber employees.</p>
                    </div>
                    <div className="mission-1">
                    <img src="https://www.pagebuildingconstruction.com/wp-content/uploads/2017/10/icon-endure.png" alt="image12"></img>
                        <h2>Endure the Test of Time</h2>
                        <p>We construct structures that are both physically functional, aesthetically pleasing, spiritually uplifting and will endure the test of time. We conduct our business with quiet competence.</p>
                    </div>

                </div>
            </div>









            <div className="strength">
                <div className="str-word">
                    <h1>OUR STRENGTH</h1>
                    <p>Our strengths are our commitment to quality and integrity, our dedication to our clients and our strong belief that the actions of this company will lead to its growth. We commit to these values to guide our decisions and behavior.</p>
                </div>
                <div className="str-stat">
                    <div className="stat-1">
                        <div className="stat-2">
                            
                            <div><h4>Commitment</h4></div>
                            <div className="stat-3"><h4>100%</h4></div>
                        </div>
                        <p>.</p>
                    </div>
                    <div className="stat-1">
                        <div className="stat-2">
                            <div><h4>Quality</h4></div>
                            <div className="stat-3"><h4>100%</h4></div>
                        </div>
                        <p>.</p>
                    </div>
                    <div className="stat-1">
                        <div className="stat-2">
                            <div><h4>Integrity</h4></div>
                            <div className="stat-3"><h4>100%</h4></div>
                        </div>
                        <p>.</p>
                    </div>
                    
                </div>
            </div>
        </div>
        </>
    );
}

export default About1;